<template>
  <div class="clean-info-box">
    <div class="main-container">
      <h3 class="">{{disp_date_text}} {{room_info.listing_name}}</h3>
      <div class="info-box">
        <div>
          <label>清掃ステータス</label>
          <p>
            <span class="status" :class="`status${room_info.status}`">{{status_text(room_info.status)}}</span>
          </p>
        </div>
        <div>
          <label>清潔さ</label>
          <p>
            <span class="assessment" :class="(room_info.assessment >= i) ? 'assessment_ok' : ''" v-for="i in 5" :key="i">★</span>
          </p>
        </div>
        <div>
          <label>備品</label>
          <p>
            <input type="radio" id="fixture1" name="fixtures" value="1" v-model="room_info.equipment" disabled>
            <label for="fixture1">有り</label>
            <input type="radio" id="fixture2" name="fixtures" value="2" v-model="room_info.equipment" disabled>
            <label for="fixture2">無し</label>
          </p>
        </div>
        <div>
          <label>備考</label>
          <p>
            <textarea name="name" rows="4" cols="80" v-model="room_info.comment" disabled></textarea>
          </p>
        </div>
        <div class="">
          <label>清掃前</label>
          <p>
            <img :src="dataUrl1" v-if="dataUrl1">
          </p>
        </div>
        <div class="">
          <label>清掃後</label>
          <p>
            <img :src="dataUrl2" v-if="dataUrl2">
          </p>
        </div>
      </div>
      <div class="btn-box">
        <input type="button" class="new-add" @click="back" value="戻る" />
        <input type="button" class="new-add" v-if="room_info.status!=3" @click="send" value="確認" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CleanInfo',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      disp_date: '',
      listing_id: 0,
      room_info: {},
      dataUrl1: null,
      dataUrl2: null,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    disp_date_text () {
      return `${this.disp_date.substr(0, 4)}/${this.disp_date.substr(4, 2)}/${this.disp_date.substr(6, 2)}`;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.disp_date = this.$route.params.date;
    this.listing_id = this.$route.params.listing_id;

    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({date: this.disp_date, listing_id: this.listing_id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('admin_cleaner_listing_get.php');
    },
    data_get_cb (res) {
      this.room_info = res.data;

      this.dataUrl1 = res.data.image_url1;
      this.dataUrl2 = res.data.image_url2;
    },
    status_text (status) {
      if (status === 1) {
        return '未清掃';
      } else if (status === 2) {
        return '清掃済み';
      } else {
        return '確認済み';
      }
    },
    back () {
      this.$router.push({name: 'clean', params: {date: this.disp_date}});
    },
    send () {
      this.$alert('alert', '清掃ステータスを「確認済み」にしますか？', this.send_ok);
    },
    send_ok () {
      let ld = new this.$loader(this);
      ld._data_set({complete_id: this.room_info.complete_id});
      ld._post_cb_f = this.send_cb;
      ld._load_start('admin_cleaner_complete.php');
    },
    send_cb () {
      this.back();
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.clean-info-box {
  text-align: left;
  padding-bottom: 56px;

  .main-container {
    h3 {
      margin-bottom: 8px;
    }
    .info-box {
      div {
        margin-bottom: 8px;
        label {
          font-size: 0.8rem;
        }
      }
      .status {
        width: 64px;
        font-size: 0.8rem;
        border-radius: 4px;
        margin-right: 8px;
        font-weight: bold;
        padding: 2px 4px;
        text-align: center;
        color: #fefefe;
      }
      .status1 {
        background: #ef8d42;
      }
      .status2 {
        background: #4284ef;
      }
      .status3 {
        background: #45b32d;
      }
      .assessment {
        display: inline-block;
        padding: 0 10px;
      }
      .assessment_ok {
        color: #e6c50d;
      }
      img {
        width: 100%;
        max-width: 500px;
      }
      label > input {
        display:none;	/* アップロードボタンのスタイルを無効にする */
      }
      .file-label {
        color: #ff6e5a;
        display: block;
        text-align: center;
        padding: 1px;
        font-size: 16px;
        text-decoration: none;
        border-radius: 3px;
        width: 150px;
        font-weight: 800;
        background-color: #f6f6f7;
        border: 1px solid #ff6e5a;
        transition: all 0.2s ease;
      }
      .file-label:hover {
        color: #24273b;
        border: 1px solid #24273b;
      }
    }
    .btn-box {
      width: calc(100% - 280px);
      margin: 24px 0 0 0;
      display: flex;
      justify-content: center;
      position: fixed;
      background: #fefefe;
      padding: 8px;
      bottom: 0;
      box-sizing: border-box;

      .new-add {
        display: block;
        text-align: center;
        padding: 8px 8px 8px 8px;
        font-size: 16px;
        text-decoration: none;
        border-radius: 3px;
        width: 150px;
      }
      .new-add:not(:first-child) {
        margin-left: 24px;
      }
    }
  }

  @media (max-width: 767px) {
    .main-container {
      .btn-box {
        width: calc(100% - 20px);
      }
    }
  }
}
</style>
